import { Sun, Cloud, CloudRain, CloudSnow, Zap } from "lucide-react";

export type WeatherType = "sunny" | "cloudy" | "rainy" | "stormy" | "partly-cloudy";

interface WeatherIconProps {
  type: WeatherType;
  className?: string;
}

export function WeatherIcon({ type, className = "w-4 h-4" }: WeatherIconProps) {
  const icons = {
    sunny: <Sun className={className} />,
    cloudy: <Cloud className={className} />,
    "partly-cloudy": <CloudSnow className={className} />,
    rainy: <CloudRain className={className} />,
    stormy: <Zap className={className} />,
  };

  return icons[type] || icons.sunny;
}
